import React, { useEffect, useRef } from 'react';
import { AnalyticsContext } from './AnalyticsContext';
import { getUtmParameters } from '../../analytics/analytics-utils';
import { UtmParameters } from '../../appTypings';
import { useAppFeaturesContext } from '../AppFeaturesContext/AppFeaturesContext';
import { useAuthContext } from '../AuthContext/AuthContext';
import { getTracker } from '../../analytics/snowplow';
import { logger } from '../../../common/logger';
import { addGlobalContexts, setUserId } from '@snowplow/browser-tracker';
import {
  consentContextGenerator,
  userProfileContextGenerator,
} from '../../analytics/snowplowContexts';

export const AnalyticsContextProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const { device, mode } = useAppFeaturesContext();
  const { user } = useAuthContext();

  const utmRef = useRef<UtmParameters>({});

  useEffect(() => {
    const { isSnowplowRunning } = getTracker(mode, device);
    if (isSnowplowRunning) {
      logger.debug('Snowplow is running');

      if (user && user.consent) {
        const version = user.consent.version;
        addGlobalContexts({
          yle_consent: consentContextGenerator({
            version: `v${version?.toString()}`,
            development: user.consent.values.development,
            personalization: user.consent.values.personalization,
            embedded_social_media: user.consent.values.embedded_social_media,
            targeting: user.consent.values.targeting,
          }),
        });

        if (user.transientId) {
          setUserId(user.transientId);

          if (user.isSubAccount) {
            const ageGroup = user.age;
            addGlobalContexts({
              user_profile: userProfileContextGenerator(ageGroup),
            });
          }
        }
      }
    }
  }, [device, mode, user]);

  return (
    <AnalyticsContext.Provider
      value={{
        setUtmParameters: (mode, isPlayer, id) => {
          utmRef.current = getUtmParameters(mode, isPlayer, id);
        },
      }}
    >
      {children}
    </AnalyticsContext.Provider>
  );
};
